import {Component, Inject, OnInit} from '@angular/core';
import {SafePipe} from '../../../../common/pipes/safe.pipe';
import {SafeHtml} from '@angular/platform-browser';
import {SharedService} from '../../../../common/services/shared-service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReturnMessageDTO} from '../../../models/ReturnMessageDTO';
import {DatePipe} from '@angular/common';
import {ReportingService} from '../../../../other/services/reporting.service';
import {FormControl} from '@angular/forms';
import {finalize, take} from 'rxjs/operators';
import {SafeStringType} from '../../../types/safe-string-type.enum';
import {JiraHelperService} from '../../../../common/services/jira-helper.service';
import {EnvironmentService} from '../../../../common/services/environment-service';

@Component({
  selector: 'app-claim-results-dialog',
  templateUrl: './claim-results-dialog.component.html',
  styleUrls: [
    './claim-results-dialog.component.scss',
    '../../../../../../styles/global/_dialog-styles.scss'
  ],
  providers: [SafePipe]
})
export class ClaimResultsDialogComponent implements OnInit {
  readonly claimHTMLReportURI: string = '/Reports/Claim_Processing_Result';
  readonly activityHTMLReportURI: string = '/Reports/Activity_Messages';

  heading: string;
  claimType: string;
  isClaim: boolean;
  isProviderPortal: boolean;
  jiraEnabled: boolean;
  jiraKeyExists: boolean;
  jiraKey: string;
  transactionId: number;
  activityIds: number[];
  html: SafeHtml;
  activityFormControl: FormControl;
  showActivityDrillDown: boolean;
  isBusyCounterInlineSpinner = 0;

  constructor(
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<ClaimResultsDialogComponent>,
    public sharedService: SharedService,
    private safePipe: SafePipe,
    private reportingService: ReportingService,
    private jiraHelperService: JiraHelperService,
    private environmentService: EnvironmentService,
    @Inject(MAT_DIALOG_DATA) public data: ReturnMessageDTO
  ) {
    this.claimType = data?.claimType;
    this.isClaim = data?.claimType === 'Claim';
    this.isProviderPortal = data?.isProviderPortal;
    this.jiraEnabled = environmentService.isJiraApiEnabled();
    this.jiraKey = data?.message;
    this.transactionId = data?.transactionId;
    this.activityIds = data?.activityIds;
    this.heading = `${this.claimType} Results`;
    this.activityFormControl = new FormControl('');
    this.showActivityDrillDown = false;
    this.jiraKeyExists = jiraHelperService.containsIssueKey(this.jiraKey);
  }

  ngOnInit(): void {
    if(this.transactionId !== null){
      this.getReportHtml(this.claimHTMLReportURI, `Transaction_Id=${this.transactionId}`);
    }
    this.sharedService.getHelpInfo('claim');
  }

  activitySelected(id: string) {
    this.showActivityDrillDown = true;
    this.getReportHtml(this.activityHTMLReportURI, `Activity_Id=${id}`);
  }

  backToTransactionResults() {
    if(this.transactionId !== null){
      this.showActivityDrillDown = false;
      this.activityFormControl.setValue('');
      this.getReportHtml(this.claimHTMLReportURI, `Transaction_Id=${this.transactionId}`);
    }
  }

  onReviewClick() {
    this.dialogRef.close(this.transactionId);
  }

  onContinueClick() {
    this.dialogRef.close(0);
  }

  getInfoTooltip(inputName: string): string {
    return this.sharedService.getInfoTooltip(inputName);
  }

  onGenerateClick($event: MouseEvent): void {
    $event.preventDefault();
    this.isBusyCounterInlineSpinner++;
    this.reportingService.generateClaimOrAuthorizationReport(this.isClaim, this.transactionId)
      .pipe(
        finalize(() => this.isBusyCounterInlineSpinner--)
      )
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.onContinueClick();
          }
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        });
  }

  onJiraClick() {
    window.open(this.jiraHelperService.getIssueUrl(this.jiraKey, this.isProviderPortal), '_blank');
  }

  private getReportHtml(uri: string, parameters: string): void {
    this.reportingService.getReportHtml(uri, parameters)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (result: string) => {
          this.html = this.safePipe.transform(result, SafeStringType.Html);
        },
        error: () => {
          this.sharedService.openErrorDialog('There was an error generating the report');
        }
      });
  }
}
